// <WorkspaceDisconnectedModal> — full-screen, non-dismissible modal shown
// when the BFF reports the workspace has been disconnected (force-unlink,
// Ring webhook revoke). The user must reinstall from the Ring App to
// recover.

import { useWorkspace } from "@/workspace";
import "./modal.css";

export function WorkspaceDisconnectedModal(): JSX.Element | null {
  const { disconnected } = useWorkspace();

  if (!disconnected) {
    return null;
  }

  return (
    <div
      className="reb-modal__backdrop reb-modal__backdrop--blocking"
      role="alertdialog"
      aria-modal="true"
    >
      <div className="reb-modal" role="document">
        <h2 className="reb-modal__title">Workspace Disconnected</h2>
        <p>
          This workspace is no longer linked to Ring. To restore access, an
          administrator must reinstall Ring Business from the Ring App
          Store.
        </p>
        <div className="reb-modal__actions">
          <a
            href="https://account.ring.com/account/app-store"
            className="reb-button reb-button--primary"
          >
            Reinstall from Ring App
          </a>
        </div>
      </div>
    </div>
  );
}
